// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1blul","calendarButtons":"ClockData_calendarButtons__3YSlL"};